/**
 * Notification Item Skeleton
 *
 * Loading placeholder matching the NotificationItem layout.
 * Uses shimmer animation consistent with the codebase skeleton system.
 *
 * @module components/notifications/NotificationItemSkeleton
 */

import React from 'react';

/**
 * Single notification skeleton row
 */
const NotificationItemSkeleton: React.FC = () => {
  return (
    <div className="flex items-start gap-3 px-4 py-3 animate-pulse">
      {/* Icon circle */}
      <div className="h-9 w-9 shrink-0 rounded-full bg-gray-200 dark:bg-gray-700" />

      {/* Text lines */}
      <div className="flex-1 space-y-2">
        <div className="h-3.5 w-3/4 rounded-sm bg-gray-200 dark:bg-gray-700" />
        <div className="h-3 w-full rounded-sm bg-gray-200 dark:bg-gray-700" />
        <div className="h-2.5 w-1/4 rounded-sm bg-gray-200 dark:bg-gray-700" />
      </div>
    </div>
  );
};

/**
 * Multiple skeleton rows for loading state
 */
export function NotificationListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="divide-y divide-gray-100 dark:divide-gray-800">
      {Array.from({ length: count }, (_, i) => (
        <NotificationItemSkeleton key={i} />
      ))}
    </div>
  );
}

export default NotificationItemSkeleton;
